import { useDispatch, useSelector } from 'react-redux'
import { CatalogsDispatch, RootState } from './types'

export const useCatalogsDispatch = () => useDispatch<CatalogsDispatch>()
export const useCatalogsSelector = useSelector.withTypes<RootState>()
